import React from 'react';
import { ROUTE_NAMES } from '../../Routes';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation } from 'react-router-dom';

import P_1 from '../../assets/press/Press-1-1.png';
import P_2 from '../../assets/press/Press-2-1.webp';
import P_3 from '../../assets/press/Press-3-1.jpg';
import P_3_2 from '../../assets/press/Press-3-2.jpg';
import P_3_3 from '../../assets/press/Press-3-3.jpg';
import P_4 from '../../assets/press/Press-5-1.jpg';

export default function PressPage3() {
  const location = useLocation();
  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

  const pressList = [
    {
      image: P_1,
      title:
        'Starlife: Construction Starts on ’21 Hollywood’ at 2100 N. Federal Highway, Hollywood, FL, 33020',
      link: ROUTE_NAMES.PRESS1,
    },
    {
      image: P_2,
      title:
        '21 Hollywood, a new 13-story mixed-use apartment development is coming to the heart of Hollywood',
      link: ROUTE_NAMES.PRESS2,
    },
    {
      image: P_4,
      title:
        'The Future of Luxury Real Estate: An Exclusive Interview with Gevorg Shahbazyan, Visionary Founder of Starlife Group',
      link: ROUTE_NAMES.PRESS4,
    },
  ];

  return (
    <div className='press-single-page'>
      <Helmet>
        <title>
          Starlife: Exclusive & Iconic: Starlife Group’s 21 Hollywood Recognized
          as the Best in Luxury Real Estate
        </title>
        <meta
          name='description'
          content='Stay updated with Starlife Group’s latest news, real estate insights, investment trends, and project announcements.'
        />
        <meta
          name='keywords'
          content='Starlife press, Real estate news, Luxury property updates, Real estate investment insights, Starlife Group announcements, Property market trends'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>
      <div className='col-1'>
        <img src={P_3} alt='press-image' />
        <h2 className='press-page-title'>
          Exclusive & Iconic: Starlife Group’s 21 Hollywood Recognized as the
          Best in Luxury Real Estate
        </h2>
        <span className='author-name'>By Totalprestige Magazine</span>
        <Link
          to={
            'https://www.totalprestigemagazine.com/exclusive-iconic-starlife-groups-21-hollywood-recognized-as-the-best-in-luxury-real-estate/'
          }
        >
          <span className='author-name'>Source</span>
        </Link>

        <div className='press-page-content'>
          <p>
            Starlife Group is where visionary design meets next-level luxury.
            Founded by the dynamic duo Gevorg Shahbazyan and Arman Shahbazyan,
            this Miami-based firm has quickly emerged as an industry powerhouse,
            redefining high-end real estate with premier developments that
            combine sophistication, innovation, and strong investment potential.
            From sleek residential masterpieces to vibrant mixed-use spaces,
            Starlife Group is shaping the future of South Florida’s skyline, one
            iconic project at a time.
          </p>
          <p>
            It comes as no surprise that Starlife Group and its groundbreaking
            project, 21 Hollywood in Florida were recently recognized by the
            prestigious Luxury Lifestyle Awards. This recognition as Best Luxury
            Residential Development for 21 Hollywood in Florida, USA has sealed
            Starlife Group’s reputation as an industry leader in ultra-luxury
            real estate development, known for creating elevated lifestyles and
            legacy-driven communities that set new standards in modern living.
          </p>
          <img src={P_2} alt='press-image' />
          <p>
            Located in vibrant Hollywood, Florida, 21 Hollywood represents the
            peak of upscale, high-rise living, where exceptional architecture,
            premium amenities, and a prime location combine to deliver
            astonishing results. Designed to cater to high-net-worth individuals
            (HNWIs) and astute investors, this exceptional development sets new
            standards for elevated lifestyles in South Florida’s booming real
            estate market.
          </p>
          <p>
            “Winning this prestigious award validates our relentless pursuit of
            excellence in luxury real estate,” said Gevorg Shahbazyan, Founder
            and CEO of Starlife Group. “With 21 Hollywood, we aimed to create
            more than just a residential development, we envisioned a lifestyle
            that harmonizes modern luxury and architectural brilliance with an
            excellent investment opportunity. We are honored to be recognized
            among the world’s top luxury developers.”
          </p>
          <img src={P_3_2} alt='press-image' />
          <p>
            With a diverse and lavish portfolio spanning residential,
            commercial, and mixed-use developments, Starlife Group has emerged
            as a trusted name in Miami’s luxury real estate scene. The company’s
            passion and drive for quality, transparency, and investor confidence
            has attracted global clientele seeking premier properties in one of
            the most sought-after real estate markets in the world.
          </p>
          <p>
            Alexander Chetchikov, President of the World Luxury Chamber of
            Commerce, praised Starlife Group’s outstanding achievement, stating:
            “The level of craftsmanship, vision, and execution that went into 21
            Hollywood is nothing short of remarkable. Starlife Group has once
            again proven why they are at the forefront of the luxury real estate
            industry, delivering projects that set new benchmarks in design,
            exclusivity, and innovation.”
          </p>
          <img src={P_3_3} alt='press-image' />
          <p>
            Starlife Group continues to contour South Florida’s skyline with
            visionary real estate solutions, ensuring each project exceeds
            expectations. For those looking to experience the height of modern
            luxury living, 21 Hollywood offers an exclusive opportunity to enjoy
            a piece of South Florida’s distinctive and leading real estate.
          </p>
        </div>
      </div>
      <div className='col-2'>
        <div className='sticky-press-list'>
          <h3>Press Articles</h3>
          {pressList.map((item, idx) => (
            <Link to={item.link} key={idx}>
              <div className='other-press-card'>
                <img src={item.image} alt={`press-${idx}`} />
                <p>{item.title}</p>
              </div>
            </Link>
          ))}
          <Link to={ROUTE_NAMES.PRESS}>
            <button className='view-all-press-btn'>View All</button>
          </Link>
        </div>
      </div>
    </div>
  );
}
